import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";

import useService from "../../../../../../hooks/useService";
import { PAYMENTS_MODAL_STYLES } from "../../../../payments/styles/styles";
import { SETTLEMENT_PAYMENT_ENTITY_QUERY_LIMIT } from "../helpers/functions";

export default function SettlementPaymentsAutocomplete({
  casePk,
  fieldName,
  fieldValue,
  onChange,
  nameKey = "name",
}) {
  const entityRepository = useService("repositories/entity-repository");
  const [options, setOptions] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!casePk) {
      setOptions([]);
      setLoading(false);
      return undefined;
    }

    let active = true;
    const timeoutId = setTimeout(async () => {
      setLoading(true);

      try {
        const response = await entityRepository.query({
          case: casePk,
          limit: SETTLEMENT_PAYMENT_ENTITY_QUERY_LIMIT,
          ordering: "name",
          ...(search ? { search } : {}),
        });

        if (active) {
          setOptions(response || []);
        }
      } catch (error) {
        if (active) {
          setOptions([]);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }, 250);

    return () => {
      active = false;
      clearTimeout(timeoutId);
    };
  }, [casePk, entityRepository, search]);

  return (
    <Autocomplete
      className="w-full"
      disablePortal={false}
      size="small"
      loading={loading}
      value={fieldValue || null}
      options={options}
      getOptionLabel={(option) => (typeof option === "string" ? option : option?.[nameKey] ?? "")}
      noOptionsText="No Results"
      onChange={(_, value) => {
        onChange(fieldName, value);
        setSearch("");
      }}
      isOptionEqualToValue={(option, value) => (option?.pk ?? option?.id) === (value?.pk ?? value?.id)}
      renderOption={(props, option) => (
        <li {...props} id={`${fieldName}-${option?.pk ?? option?.id ?? option?.[nameKey]}`} key={option?.pk ?? option?.id ?? option?.[nameKey]}>
          {option?.[nameKey]}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          className="w-full"
          sx={PAYMENTS_MODAL_STYLES.textField}
          onChange={(event) => setSearch(event.target.value)}
          size="small"
        />
      )}
    />
  );
}
